import {
  Box,
  Container,
  CssBaseline,
  Toolbar,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Layout from "../../layout/Layout";
import Fuelmanagementdashboard from "./Fuelmanagementdashboard";
import { routeModules } from "../../../src/config/routeconfig";
import Loading from "../../common/Laoding";
import Viewallfuel from "./Viewallfuel";
import Addfuelrequest from "./Addfuelrequest";
import { useNavigate } from "react-router-dom";

const navItems = routeModules?.fuelmanagement?.sidebar;

const Fuelmanagementmodule = () => {
  const navigate = useNavigate();
  const [activeItem, setActiveItem] = useState(navItems[0]?.label || "");
  const [isLoading, setIsLoading] = useState(true);

  const renderContent = () => {
    switch (activeItem) {
      case "Fuel Dashboard":
        return <Fuelmanagementdashboard />;
      case "Add Fuel Details":
        return <Addfuelrequest setActiveItem={setActiveItem} />;
      case "View All":
        return <Fuelmanagementdashboard />;
      default:
        return <Typography>Need Access</Typography>;
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false); // Stop loading after 2 seconds
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  // const isSessionValid = () => {
  //   const loginTime = localStorage.getItem("loginTime");
  //   if (!loginTime) return false;
  //   return Date.now() - Number(loginTime) <= 2 * 60 * 60 * 1000;
  // };

  // useEffect(() => {
  //   if (!isSessionValid()) {
  //     localStorage.clear();
  //     navigate("/");
  //   }
  // }, []);

  if (isLoading) {
    return <Loading />;
  }
  return (
    <div>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <Layout
          module={"fuelmanagement"}
          activeItem={activeItem}
          setActiveItem={setActiveItem}
        />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            backgroundImage: "linear-gradient(to top, #ffffff, #d4dfed)",
            // p: 3,
          }}
        >
          <Toolbar />
          <Container
            maxWidth={false}
            sx={{
              height: "100vh",
              overflowY: "scroll",
              scrollbarWidth: "none", // Firefox
              "&::-webkit-scrollbar": {
                display: "none", // Chrome, Safari
              },
            }}
          >
            {renderContent()}
          </Container>
        </Box>
      </Box>
    </div>
  );
};

export default Fuelmanagementmodule;
